import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import CityBreadCrumb from "../components/CityBreadCrumb";
import CountrySearch from "../components/CountrySearch";
import BrowseByCities from "../components/BrowseByCities";
import CityListStore from "../store/cityListStore";

function CountrySearchPage() {
  const cityList = CityListStore((state) => state.cityList);
  
  return (
    <div className="font-inter flex flex-col min-h-screen">
      <Navbar />
      <div className="container mx-auto px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 2xl:px-24 my-10 mt-5">
        <CityBreadCrumb/>
        <CountrySearch/>
        <BrowseByCities cityData={cityList}/>
      </div>
      <Footer />
    </div>
  );
}

export default CountrySearchPage;